import React from 'react';
import { Link } from 'react-router-dom';
import './BlogPage.scss';

interface BlogPageProps {
  menuOpen: boolean;
}

const BlogPage: React.FC<BlogPageProps> = ({ menuOpen }) => {
  return (
    <div className={`blog-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="blog-page__hero">
        <div className="blog-page__content">
          <h1 className="blog-page__title">YOUR BOOKING</h1>
          <div className="blog-page__intro">
            <h2>Wedding Insights & Stories</h2>
            <p>
              Explore our blog for wedding inspiration, tips for couples, and behind-the-scenes looks at our recent projects.
              We share our expertise to help you plan your perfect wedding day and create beautiful memories.
            </p>
          </div>
          
          <div className="blog-page__grid">
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=500&auto=format&fit=crop" alt="Wedding Venue Selection" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">September 15, 2025</span>
                <h3>How to Choose the Perfect Wedding Venue</h3>
                <p>
                  Finding the right venue sets the tone for your entire wedding day. In this post, we explore 
                  key considerations to help you find a location that matches your vision and budget.
                </p>
                <Link to="/blog/choosing-perfect-wedding-venue" className="blog-post__link">Read More</Link>
              </div>
            </div>
            
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1532712938310-34cb3982ef74?q=80&w=500&auto=format&fit=crop" alt="Wedding Videography Trends" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">August 28, 2025</span>
                <h3>Top Wedding Videography Trends for 2026</h3>
                <p>
                  From cinematic drone shots to intimate documentary-style coverage, we break down the latest 
                  trends in wedding videography and how they can enhance your wedding film.
                </p>
                <Link to="/blog/top-wedding-videography-trends" className="blog-post__link">Read More</Link>
              </div>
            </div>
            
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?q=80&w=500&auto=format&fit=crop" alt="Emma & James' Countryside Wedding" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">August 10, 2025</span>
                <h3>Real Wedding: Emma & James' Countryside Celebration</h3>
                <p>
                  Step behind the scenes of Emma and James' beautiful countryside wedding and see how we 
                  captured their special day from preparation to the last dance.
                </p>
                <Link to="/blog/real-wedding-emma-james" className="blog-post__link">Read More</Link>
              </div>
            </div>
            
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?q=80&w=500&auto=format&fit=crop" alt="Coordinating Photographer and Videographer" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">July 12, 2025</span>
                <h3>How to Coordinate Your Photographer and Videographer</h3>
                <p>
                  Having both photography and videography at your wedding? Learn how to ensure these 
                  professionals work together seamlessly to capture your day.
                </p>
                <Link to="/blog/coordinating-photographer-videographer" className="blog-post__link">Read More</Link>
              </div>
            </div>
            
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1537633552985-df8429e8048b?q=80&w=500&auto=format&fit=crop" alt="Perfect Wedding Timeline" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">June 30, 2025</span>
                <h3>The Perfect Wedding Timeline: A Videographer's Perspective</h3>
                <p>
                  Planning your wedding day schedule? Our team shares insights on creating a timeline 
                  that allows for beautiful footage whilst keeping your day relaxed and enjoyable.
                </p>
                <Link to="/blog/perfect-wedding-timeline" className="blog-post__link">Read More</Link>
              </div>
            </div>
            
            <div className="blog-post">
              <div className="blog-post__image">
                <img src="https://images.unsplash.com/photo-1537633552985-df8429e8048b?q=80&w=500&auto=format&fit=crop" alt="Perfect Wedding Timeline" />
              </div>
              <div className="blog-post__content">
                <span className="blog-post__date">July 25, 2025</span>
                <h3>Tips for Looking Natural on Camera on Your Wedding Day</h3>
                <p>
                  Feeling nervous about being filmed? Our professional videographers share their top tips for looking and 
                  feeling comfortable in front of the camera.
                </p>
                <Link to="/blog/looking-natural-on-camera" className="blog-post__link">Read More</Link>
              </div>
            </div>
          </div>
          
          <div className="blog-page__pagination">
            <button className="pagination-btn active">1</button>
            <button className="pagination-btn">2</button>
            <button className="pagination-btn">3</button>
            <button className="pagination-btn next">Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
